import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  message: {
    color: theme.palette.primary.main,
  },
}))
